import { EnqueueSnackbar } from "notistack";
import { APIRoutes } from "../../../../constants";
import { RequestServer } from "../../../../utils/services";
import { ClientAgendasApiResponse, SetClientAgendasData } from "./type";


export async function getClientAgendas(setAgendaData: SetClientAgendasData, enqueueSnackbar: EnqueueSnackbar, setLoading: (b: boolean) => void, fk_project: string) {
    try {
        setLoading(true);
        const response: ClientAgendasApiResponse = await RequestServer(APIRoutes.PE_CLIENT_AGENDAS + "?fk_project=" + fk_project,"GET");

        if(response.success) {
            setAgendaData(response.data);
        } else {
            enqueueSnackbar(response.message || "Something went wrong");
        }
        
    } catch(err) {
        enqueueSnackbar("Request Failed..");
        console.log(err);
    } finally {
        setLoading(false);
    }
}

export const agendaTabOptions = [
    { label: "Experts View", value: "experts" },
    { label: "Questions View", value: "questions" },
  ];